import { MaskInput } from '@cmpsr/components';
import { FC, useRef } from 'react';
import { type DecisionTreeInputProps } from './types';

export const DecisionTreeInput: FC<DecisionTreeInputProps> = ({ trailingMask, ...props }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const isA1CQuestion = props.questionId === 'question_biomarkers_a1c';

  return (
    <MaskInput
      ref={inputRef}
      maskOptions={{
        mask: /^\d{0,5}(\.\d{0,2})?$/,
        postfix: ` ${trailingMask}`,
      }}
      pattern="[0-9]*"
      inputMode={isA1CQuestion ? 'decimal' : 'numeric'}
      autoComplete="off"
      textAlign="center"
      {...props}
    />
  );
};
